$('.invalid-feedback').each(function (e) {
    var target = '#' + $(this).closest('.tab-pane').attr('id');
    if (!$('a.nav-link[href="' + target + '"]').hasClass('active')) {
        $('a.nav-link[href="' + target + '"]').addClass('text-danger');
    }
});

$('.is-invalid').each(function (e) {
    var target = '#' + $(this).closest('.tab-pane').attr('id');
    if (!$('a.nav-link[href="' + target + '"]').hasClass('active')) {
        $('a.nav-link[href="' + target + '"]').addClass('text-danger');
    }
});

$('a.nav-link.text-danger').on('click', function () {
    $(this).removeClass('text-danger');
})
